export const API = {
    // Clients and authorization
    GetProfile: () => 'auth/profile',
    GetClient: () => `client`,
    UpdateClient: () => `client/update`,
    UpdateClientReviewPlatform: () => `client/update-review-platform`,
    TriggerDiscountSync: () => `discount-sync/sync`,
    GetDiscountSyncStatus: () => `discount-sync/status`,

    // Tracking Pixels
    UpdateTrackingPixels: () => `tracking-pixels/update`,
    GetAuthenticatedUploadSignature: () =>
        `playlist/authenticated-upload-signature`,
    GetAllUsers: () => 'users/all',
    DeleteUser: () => `users/delete`,
    UpdateUser: () => `users`,

    GetAvailableClients: () => 'users/available-clients',

    GetAllVideos: () => `video/all`,
    GetAuthenticatedUploadURL: () => `video/authenticated-url`,
    CreateS3UploadUrlForVideo: () => `video/create-s3-upload-url`,
    CreateVideo: () => `video/create`,
    GetVideo: (videoHash: string) => `video/${videoHash}`,
    CreatePromptLabRun: () => 'api/prompt-lab/run/create',
    GetPromptLabPairs: () => 'api/prompt-lab/pair/all',
    GetAllLayoutReferences: () => 'api/layout-references',
    CreateLayoutReference: () => 'api/layout-references',
    UpdateLayoutReference: (id: number) => `api/layout-references/${id}`,
    DeleteLayoutReference: (id: number) => `api/layout-references/${id}`,
    GetAllLayoutFormats: () => 'api/layout-references/formats',
    CreateLayoutFormat: () => 'api/layout-references/formats',
    UpdateLayoutFormat: (id: number) => `api/layout-references/formats/${id}`,
    DeleteLayoutFormat: (id: number) => `api/layout-references/formats/${id}`,
    GetAllBrandCategories: () => 'api/layout-references/categories',
    CreateBrandCategory: () => 'api/layout-references/categories',
    UpdateBrandCategory: (id: number) =>
        `api/layout-references/categories/${id}`,
    DeleteBrandCategory: (id: number) =>
        `api/layout-references/categories/${id}`,
    GetStorefrontReviewScoreTrend: (days: number) =>
        `api/storefront-review-score/trend?days=${days}`,
    GetJudgeCalibrationNext: (skip: number) =>
        `api/judge-calibration/next?skip=${skip}`,
    PostJudgeCalibrationScore: () => 'api/judge-calibration/score',
    DeleteVideo: (videoHash: string) => `video/${videoHash}/delete`,
    UpdateVideo: (videoHash: string) => `video/${videoHash}/update`,

    GetAllPlaylists: () => `playlist/all`,
    GetPlaylist: (playlistHash: string) => `playlist/${playlistHash}`,
    GetLandingPagePlaylist: (playlistHash: string) =>
        `playlist/lp-playlist/${playlistHash}`,
    CreatePlaylist: () => `playlist/create`,
    UpdatePlaylist: (playlistHash: string) => `playlist/${playlistHash}/update`,

    GetAllCollections: () => 'collection/all',
    GetCollection: (collectionHash: string) => `collection/${collectionHash}`,
    CreateCollection: () => `collection/create`,
    UpdateCollection: (collectionHash: string) =>
        `collection/${collectionHash}/update`,
    DeleteCollection: (collectionHash: string) =>
        `collection/${collectionHash}/delete`,

    // Virtual Products
    GetAllVirtualProducts: () => `virtual-product/all`,
    GetVirtualProduct: (id: number) => `virtual-product/${id}`,
    CreateVirtualProduct: () => `virtual-product/create`,
    UpdateVirtualProduct: (id: number) => `virtual-product/${id}/update`,
    DuplicateVirtualProduct: (id: number) => `virtual-product/${id}/duplicate`,
    ChangeParentVirtualProduct: (id: number) =>
        `virtual-product/${id}/change-parent`,
    BulkReplaceNonVirtual: () => `virtual-product/bulk-replace-non-virtual`,
    GetRelatedProducts: () => `virtual-product/related-products`,
    QueueVirtualProductSetup: () => `virtual-product/queue-setup`,
    GetVirtualProductUsage: (id: number) => `virtual-product/${id}/usage`,
    DeleteVirtualProduct: (id: number) => `virtual-product/${id}/delete`,
    SubstituteVirtualProductInStorefronts: (id: number) =>
        `virtual-product/${id}/substitute-in-storefronts`,
    DiscoverProductFamilies: () => `product-families/discover`,
    PersistProductFamilies: () => `product-families/persist`,
    ListProductFamilies: () => `product-families`,
    SetProductFamilyActive: () => `product-families/active`,

    // Product Options
    GetAllProductOptions: () => `product-option/all`,
    CreateProductOption: () => `product-option/create`,
    UpdateProductOption: (id: number) => `product-option/${id}/update`,
    DeleteProductOption: (id: number) => `product-option/${id}/delete`,
    QueueOptionExtraction: () => `product-option/queue-option-extraction`,
    QueueSwatchExtraction: () => `product-option/queue-swatch-extraction`,

    // Landing Pages
    GetAllLandingPages: () => `landingpage`,
    GetLandingPage: (landingPageHash: string) =>
        `landingpage/${landingPageHash}`,
    GetLandingPageContent: (landingPageHash: string) =>
        `landingpage/${landingPageHash}/content`,
    GetLandingPageSourceAd: (landingPageHash: string) =>
        `landingpage/${landingPageHash}/source-ad`,
    GetLandingPageOrderLineItemSummary: (landingPageHash: string) =>
        `landingpage/${landingPageHash}/order-line-item-summary`,
    GetCrowLinksByLandingPage: (landingPageHash: string) =>
        `landingpage/${landingPageHash}/crowlink`,
    CreateLandingPage: () => `landingpage/create`,
    DuplicateLandingPage: () => `landingpage/duplicate`,
    UpdateLandingPageContent: () => `landingpage/update-content`,
    UpdateLandingPage: () => `landingpage/update`,
    UpdateLandingPageLinks: () => `landingpage/update-links`,
    UpdateLandingPageCartUpsells: () => `landingpage/update-cart-upsells`,
    SaveLandingPage: (landingPageHash: string) =>
        `landingpage/${landingPageHash}`,
    ListPlacementOptionRules: (landingPageHash: string) =>
        `landingpage/${landingPageHash}/placement-options`,
    GetPlacementOptionRulesForLink: (
        landingPageHash: string,
        linkHash: string,
    ) => `landingpage/${landingPageHash}/placement-options/link/${linkHash}`,
    CreatePlacementOptionRule: (landingPageHash: string, linkHash: string) =>
        `landingpage/${landingPageHash}/placement-options/link/${linkHash}/rules`,
    UpdatePlacementOptionRule: (landingPageHash: string, ruleId: number) =>
        `landingpage/${landingPageHash}/placement-options/rules/${ruleId}`,
    DeletePlacementOptionRule: (landingPageHash: string, ruleId: number) =>
        `landingpage/${landingPageHash}/placement-options/rules/${ruleId}`,
    DeleteAllPlacementOptionRulesForLink: (
        landingPageHash: string,
        linkHash: string,
    ) =>
        `landingpage/${landingPageHash}/placement-options/link/${linkHash}/rules`,

    // Edit Chat
    CreateEditChatSession: (landingPageHash: string) =>
        `landingpage/${landingPageHash}/edit-chat`,
    GetEditChatSession: (landingPageHash: string, sessionId: string) =>
        `landingpage/${landingPageHash}/edit-chat/${sessionId}`,
    PostEditChatMessage: (landingPageHash: string, sessionId: string) =>
        `landingpage/${landingPageHash}/edit-chat/${sessionId}/messages`,
    CancelEditChatTurn: (landingPageHash: string, sessionId: string) =>
        `landingpage/${landingPageHash}/edit-chat/${sessionId}/cancel`,
    /** AG-UI hydrate + turn event SSE (transcript, state, workspace). */
    GetEditChatAgUiEvents: (landingPageHash: string, sessionId: string) =>
        `landingpage/${landingPageHash}/edit-chat/${sessionId}/ag-ui`,
    GetEditChatAttachmentUploadSignature: (landingPageHash: string) =>
        `landingpage/${landingPageHash}/edit-chat/attachment-upload-signature`,

    PostCropFit: (landingPageHash: string) =>
        `landingpage/${landingPageHash}/crop-fit`,

    // Storefront AI Feedback
    PostStorefrontAiFeedback: (landingPageHash: string) =>
        `landingpage/${landingPageHash}/ai-feedback`,
    PostEditChatMessageFeedback: (
        landingPageHash: string,
        sessionId: string,
        messageId: string,
    ) =>
        `landingpage/${landingPageHash}/ai-feedback/edit-chat/${sessionId}/messages/${messageId}`,

    // Storefront Tags
    GetStorefrontTags: () => `storefront-tag`,
    CreateStorefrontTag: () => `storefront-tag`,
    AssignStorefrontTag: () => `storefront-tag/assign`,
    RenameStorefrontTag: (tagHash: string) => `storefront-tag/${tagHash}`,
    AssignStorefrontTagByHash: (tagHash: string) =>
        `storefront-tag/${tagHash}/assign`,
    DeleteStorefrontTag: (tagHash: string) => `storefront-tag/${tagHash}`,

    // Gift Promotions
    GetGiftPromotions: () => `gift-promotion`,
    CreateGiftPromotion: () => `gift-promotion`,
    UpdateGiftPromotion: (giftPromotionHash: string) =>
        `gift-promotion/${giftPromotionHash}`,
    DeleteGiftPromotion: (giftPromotionHash: string) =>
        `gift-promotion/${giftPromotionHash}`,

    // Landing Page Templates
    GetAllStorefrontGeneratorLandingPages: () =>
        `landingpage-template/storefront-generator-landing-pages`,
    GetAllLandingPageTemplates: () => `landingpage-template/`,
    CreateLandingPageTemplate: () => `landingpage-template/`,
    UpdateLandingPageTemplate: (templateId: number) =>
        `landingpage-template/${templateId}`,
    DeleteLandingPageTemplate: (templateId: number) =>
        `landingpage-template/${templateId}`,
    GetTemplatesRankedByAi: () => `landingpage-template/ai-ranked`,
    GetTemplatePreview: (landingPageHash: string) =>
        `landingpage-template/preview/${landingPageHash}`,

    // Images
    GetAllImages: () => `image`,
    UploadImage: () => `image`,
    UploadImages: () => `landingpage/upload-images`,

    // Landing Page Links
    GetAllLandingPageLinks: () => `landingpagelink/all`,
    GetPaginatedLandingPageLinks: () => `landingpagelink/paginated`,
    GetLandingPageLink: (landingPageLinkHash: string) =>
        `landingpagelink/${landingPageLinkHash}`,
    GetLandingPageLinksBatch: () => `landingpagelink/batch`,
    GetLandingPageLinkByVirtualProductId: (virtualProductId: number) =>
        `landingpagelink/virtual-product/${virtualProductId}`,
    UpdateLandingPageLinkContent: () => `landingpagelink/update-content`,
    UpdateLandingPageLinkMetadata: () => `landingpagelink/update-metadata`,
    GetAllUnimportedShopifyProducts: () =>
        `landingpagelink/unimported-shopify-products`,
    GetAllShopifyCollections: () => `landingpagelink/all-shopify-collections`,
    GetAllShopifyProducts: () => `landingpagelink/all-shopify-products`,
    GetAllProductsOrderedByRelevance: () =>
        `landingpagelink/all-products-ordered-by-relevance`,
    GetAllProductsOrderedByRelevanceToMetaAd: (metaAdId: string) =>
        `landingpagelink/all-products-ordered-by-relevance-to-meta-ad/${metaAdId}`,
    GetShopifyProductById: (shopifyId: string) =>
        `landingpagelink/shopify-product/${shopifyId}`,
    ImportShopifyProduct: () => `landingpagelink/import-shopify-product`,
    ImportShopifyCollection: () => `landingpagelink/import-shopify-collection`,
    BatchImportTopProducts: () => `landingpagelink/batch-import-top-products`,
    ResyncImagesForLandingPageLink: () => `landingpagelink/resync-images`,
    RegeneratePDPForLandingPageLink: () => `landingpagelink/regenerate-pdp`,
    GetPDPRegenerationStatus: (jobId: string) =>
        `landingpagelink/regenerate-pdp/${jobId}`,
    RegenerateAllPDPs: () => `landingpagelink/regenerate-all-pdps`,
    QueueReviewAnalysis: (linkHash: string) =>
        `landingpagelink/${linkHash}/queue-review-analysis`,
    QueueAllReviewAnalysis: () => `landingpagelink/queue-review-analysis`,
    GetActivePDPJobsCount: () => `landingpagelink/pdp-jobs/active-count`,
    GetDynamicGridProductsBatch: () =>
        `landingpagelink/dynamic-grid-products/batch`,
    GetCollectionsForProduct: (linkHash: string) =>
        `landingpagelink/${linkHash}/collections`,
    UploadReviewsCsvCreateURL: () =>
        `landingpagelink/upload-reviews-csv/create-upload-url`,
    ProcessReviewsCsv: () => `landingpagelink/upload-reviews-csv/process-file`,

    // Analytics
    GetExploCustomerToken: () => `explo/token`,
    GetFullFunnelAggregations: () => 'metrics/full-funnel-aggregations',
    GetFunnelOverviewMetrics: () => 'metrics/funnel-overview',
    GetFunnelReport: () => 'metrics/funnel-report',
    GetTopPerformingCreatives: () => 'metrics/top-performing-creatives',
    GetLiveExperiments: () => 'metrics/live-experiments',
    GetExperimentsList: () => 'metrics/experiments',
    GetStorefrontMetrics: () => `metrics/storefront-metrics`,

    // Crow Links
    GetAllCrowLinks: () => 'crowlink',
    CreateCrowLink: () => 'crowlink/create',
    CreateManyCrowLinks: () => 'crowlink/bulk',
    GetCrowLink: (linkHash: string) => `crowlink/${linkHash}`,
    UpdateCrowLink: (linkHash: string) => `crowlink/${linkHash}`,
    CreateExperimentGroup: () => 'experiment-group',

    // Crow Link Experiments
    GetExperimentDetails: (experimentId: string) =>
        `crowlink/experiment/${experimentId}`,
    UpdateExperimentDetails: (experimentId: string) =>
        `crowlink/experiment/${experimentId}`,
    GetExperimentMetrics: (experimentId: string) =>
        `metrics/experiment-metrics/${experimentId}`,

    // Personas
    GetAllPersonas: () => 'personas',
    CreatePersona: () => 'personas/create',
    UpdatePersona: (id: number) => `personas/${id}`,
    DeletePersona: (id: number) => `personas/${id}`,
    QueuePersonaGeneration: () => 'personas/queue-generation',
    PersonaGenerationStatus: () => 'personas/generation-status',

    // AI Create Session
    CreateAICreateSession: () => 'ai-create-session',
    CreateAICreateSessionRun: (sessionId: string) =>
        `ai-create-session/${sessionId}/runs`,
    GetAICreateSessionEvents: (sessionId: string) =>
        `ai-create-session/${sessionId}/events`,
    GetAICreateSessionAgUiEvents: (sessionId: string) =>
        `ai-create-session/${sessionId}/ag-ui`,

    // Meta Ads
    GetMetaAds: () => 'meta-ads',

    // Client Settings
    UpdateGoogleFontFamily: () => 'client/settings/google-font-family',
    UpdateCustomFontFamily: () => 'client/settings/custom-font-family',
    GetCustomFontFamilies: () => 'font',
    UploadCustomFontFiles: () => 'font/bulk',
    ImportWebsiteFonts: () => 'font/import',
    GetClientSettings: () => 'client/settings',
    SearchGoogleFonts: () => 'client/settings/google-fonts',
    UpdateClientSettings: () => 'client/settings',
    GetTypographyRoleOverrides: () => 'typography-role-override',
    UpsertTypographyRoleOverrides: () => 'typography-role-override/bulk',

    // Brand Guidelines
    CreateBrandGuideline: () => 'client/settings/brand-guideline',
    UpdateBrandGuideline: (id: number) =>
        `client/settings/brand-guideline/${id}`,
    DeleteBrandGuideline: (id: number) =>
        `client/settings/brand-guideline/${id}`,
    UndoBrandGuideline: (id: number) =>
        `client/settings/brand-guideline/${id}/undo`,

    // Brand Benefits
    BulkReplaceBrandBenefits: () => 'brand-benefit/bulk',

    // Promotions
    BulkReplacePromotions: () => 'promotion/bulk',
    Promotion: (id: number) => `promotion/${id}`,
    CreateScheduledPromotion: () => 'scheduled-promotion',
    ScheduledPromotion: (id: number) => `scheduled-promotion/${id}`,
    DiscountCodeLookup: () => 'discount-code/lookup',

    // App install urls
    GetFacebookAppInstallUrl: () => 'client/facebook/app-install-url',

    // Slack
    GetSlackChannelInvite: () => 'slack/channel',

    // Client Onboarding
    GetClientOnboarding: () => 'clientonboarding',
    UpdateClientOnboarding: () => 'clientonboarding/update',

    // Get the shopify subscriptions
    GetAllSubscriptions: () => 'shopify/subscriptions',

    // Web Scraper
    ScrapeMedia: () => 'webscraper',
}
